// SEO-rich content for the public homepage (visible text + FAQ).
// Kept here so both the page and the JSON-LD (App.js) use the same source.
//
// VIGTIGT: VB står for varebil, ikke bus. VB GU er grunduddannelsen til
// varebilchauffør. Teksterne her kaldte den tidligere en buschaufføruddannelse,
// hvilket modsagde både courseFacts.js og sprogsidernes egen FAQ.
//
// AMU: kun taxauddannelsen, VB GU, VB EU og EVS udbydes som AMU, og det sker gennem
// samarbejdspartneren UCplus. Vognmandsuddannelserne er myndighedsrelaterede forløb,
// hvor Votra er godkendt prøveudbyder, og IT- og AI-forløbene er private kurser.
// Kilde: data/courseFacts.js (feltet `kind` pr. kursus). Udvid ikke claimet herfra.

export const HOME_INTRO = {
  heading: "Bliv vognmand, taxachauffør eller varebilchauffør",
  paragraphs: [
    "Hos Votra Vognmandsuddannelser uddanner vi fremtidens chauffører og vognmænd i hele Danmark. Uanset om du vil tage en vognmandsuddannelse til lastbil eller varebil, et taxakursus eller grunduddannelsen til varebilchauffør (VB GU), finder du et forløb, der passer til dine mål, med erfarne undervisere og høj beståelsesprocent.",
    "Taxauddannelsen, VB GU, VB EU og evakueringsstol udbydes som AMU-forløb gennem vores samarbejdspartner UCplus, der afholder undervisningen. Vognmandsuddannelserne er myndighedsrelaterede forløb, hvor Votra Danmark ApS er godkendt prøveudbyder hos Færdselsstyrelsen, og IT- og AI-forløbene er private kursusforløb. Flere af forløbene kan tages med tilskud, hvis du er ledig eller henvist via dit jobcenter eller din a-kasse.",
    "Skal du have papirerne i orden som selvstændig vognmand? Vognmandsuddannelsen giver dig den teori, der kræves for at søge tilladelse til gods- eller persontransport. Vil du køre taxa? Taxakurset klæder dig på til at blive certificeret taxachauffør. Vi hjælper dig hele vejen, fra tilmelding til bestået eksamen.",
  ],
};

export const HOME_FAQ = [
  {
    q: "Hvordan bliver jeg vognmand?",
    a: "For at blive vognmand skal du bestå vognmandsuddannelsen, som giver dig den nødvendige teori til at søge tilladelse til gods- eller persontransport. Hos Votra tilbyder vi vognmandsuddannelse til både lastbil og varebil med erfarne undervisere og online tilmelding.",
  },
  {
    q: "Hvad koster en vognmandsuddannelse?",
    a: "Prisen afhænger af kurset og dit sprog. Vognmand til lastbil koster fra 14.900 kr. og vognmand til varebil fra 6.900 kr. Er du ledig, kan kurset ofte tages med tilskud via jobcenter eller a-kasse. Se de aktuelle priser på det enkelte kursus.",
  },
  {
    q: "Hvordan bliver jeg taxachauffør?",
    a: "Du bliver taxachauffør ved at gennemføre den lovpligtige taxauddannelse. Votra Danmark ApS står på Færdselsstyrelsens liste over godkendte udbydere, og forløbet udbydes som AMU gennem vores samarbejdspartner UCplus, der afholder undervisningen. Chaufførkortet udstedes af Færdselsstyrelsen. Se kommende datoer i kursuskalenderen og tilmeld dig online.",
  },
  {
    q: "Kan jeg få tilskud til kurset, hvis jeg er ledig?",
    a: "Ja. Mange af Votras kurser kan tages med tilskud, hvis du er ledig og henvist via dit jobcenter eller din a-kasse. Kontakt os, så hjælper vi dig med at afklare dine muligheder.",
  },
  {
    q: "Hvor afholder Votra kurser?",
    a: "Votra afholder kurser flere steder i Danmark. Se vores afdelinger og adresser, eller find det nærmeste hold i kursuskalenderen.",
  },
  {
    q: "Hvordan tilmelder jeg mig et kursus?",
    a: "Du tilmelder dig nemt online: vælg dit kursus, find en ledig dato i kalenderen og udfyld tilmeldingen. Du modtager herefter en bekræftelse og et velkomstbrev med al praktisk information.",
  },
];


export const LEDIGE_INTRO = {
  heading: "Kom i job i transportbranchen",
  paragraphs: [
    "Er du ledig og klar til en ny start? Transportbranchen mangler chauffører og vognmænd, og med den rette uddannelse kan du hurtigt komme i job. Votra tilbyder vognmandsuddannelser, taxakurser og chaufføruddannelser, der giver dig de kvalifikationer, arbejdsgiverne efterspørger.",
    "Som ledig kan du ofte tage kurset med tilskud, fx via 6-ugers jobrettet uddannelse eller efter aftale med dit jobcenter eller din a-kasse. Vi rådgiver dig gerne om dine muligheder, så du ved præcis, hvad der skal til, før du går i gang.",
    "Et kursus hos Votra er en konkret vej videre: du får et anerkendt bevis, praktiske kompetencer og adgang til et arbejdsmarked med gode jobmuligheder i hele Danmark.",
  ],
};

export const LEDIGE_FAQ = [
  {
    q: "Kan jeg tage et kursus, mens jeg er ledig?",
    a: "Ja. Som ledig kan du ofte deltage via 6-ugers jobrettet uddannelse eller efter aftale med dit jobcenter eller din a-kasse. Kontakt os, så hjælper vi dig med at afklare dine muligheder.",
  },
  {
    q: "Hvilke kurser giver bedst jobmuligheder?",
    a: "Vognmandsuddannelse (lastbil/varebil), taxakursus og grunduddannelsen til varebilchauffør (VB GU) fører alle til erhverv med stor efterspørgsel efter arbejdskraft i Danmark.",
  },
  {
    q: "Hvad koster det, hvis jeg er ledig?",
    a: "Mange kurser kan tages med tilskud, når du er henvist via jobcenter eller a-kasse, i nogle tilfælde uden egenbetaling. De konkrete vilkår afhænger af din situation; kontakt os for en uforpligtende afklaring.",
  },
  {
    q: "Hvor hurtigt kan jeg komme i gang?",
    a: "Se kursuskalenderen for de næste ledige hold. Når din tilmelding og eventuelle jobcenter-godkendelse er på plads, kan du som regel starte hurtigt.",
  },
];

export const JOBCENTRE_INTRO = {
  heading: "Samarbejde med jobcentre & a-kasser",
  paragraphs: [
    "Votra samarbejder med jobcentre og a-kasser i hele Danmark om opkvalificering til transportbranchen. Vi gør det nemt at henvise ledige til vognmandsuddannelser, taxakurser og chaufføruddannelser, der fører direkte mod beskæftigelse.",
    "Taxauddannelsen, VB GU, VB EU og evakueringsstol udbydes som AMU-forløb gennem vores samarbejdspartner UCplus og kan i mange tilfælde indgå i jobrettet uddannelse (6-ugers) eller andre ordninger. Vognmandsuddannelserne er myndighedsrelaterede forløb, hvor Votra er godkendt prøveudbyder hos Færdselsstyrelsen. Vi hjælper med tilmelding og dokumentation, så sagsbehandlingen bliver enkel for både borger og jobcenter.",
    "Vil I indgå et fast samarbejde om holdpladser eller skræddersyede forløb til en gruppe ledige? Kontakt os, så finder vi en løsning, der matcher jeres behov og det lokale arbejdsmarked.",
  ],
};

export const JOBCENTRE_FAQ = [
  {
    q: "Kan jobcentret henvise ledige til Votras kurser?",
    a: "Ja. Jobcentre og a-kasser kan henvise ledige til vores forløb. AMU-forløbene, taxauddannelsen, VB GU, VB EU og evakueringsstol, udbydes gennem vores samarbejdspartner UCplus og kan fx indgå i jobrettet uddannelse (6-ugers). Vi hjælper med tilmelding og dokumentation.",
  },
  {
    q: "Kan I lave skræddersyede forløb til en gruppe ledige?",
    a: "Ja. Vi opretter gerne dedikerede hold eller tilpassede forløb for grupper af ledige i samarbejde med jobcentret eller a-kassen.",
  },
  {
    q: "Hvilken dokumentation får borgeren?",
    a: "Deltageren modtager et anerkendt kursusbevis ved bestået forløb, som kan bruges i jobsøgning og over for arbejdsgivere.",
  },
];

export const OMOS_INTRO = {
  heading: "Din uddannelsespartner i transportbranchen",
  paragraphs: [
    "Votra Vognmandsuddannelser er specialister i at uddanne vognmænd, taxachauffører og chauffører i hele Danmark. Med erfarne undervisere, moderne materialer og en høj beståelsesprocent hjælper vi både private og virksomheder godt videre.",
    "Vi tilbyder alt fra vognmandsuddannelse til lastbil og varebil over taxakurser til grunduddannelse og efteruddannelse for varebilchauffører (VB GU/VB EU) og specialkurser som BAB.",
    "Vores mission er enkel: at gøre vejen til et job, eller en virksomhed, i transportbranchen så ligetil som muligt, med ordentlig undervisning og personlig vejledning hele vejen.",
  ],
};

export const KONTAKT_INTRO = {
  heading: "Vi sidder klar til at hjælpe dig",
  paragraphs: [
    "Har du spørgsmål til en vognmandsuddannelse, et taxakursus eller en chaufføruddannelse? Vores team hjælper dig med at finde det rette forløb, afklare priser og tilskudsmuligheder og komme godt i gang.",
    "Skriv til os på kundeservice@votra.dk, det er den hurtigste vej til svar, og så har du det også på skrift. Du er også velkommen til at ringe eller besøge en af vores afdelinger i åbningstiden.",
  ],
};

export const KONTAKT_FAQ = [
  {
    q: "Hvordan kontakter jeg Votra hurtigst?",
    a: "Den hurtigste vej er at sende en mail til kundeservice@votra.dk, vi svarer typisk inden for 24 timer. Du kan også ringe i åbningstiden.",
  },
  {
    q: "Kan jeg få vejledning, før jeg tilmelder mig?",
    a: "Ja. Kontakt os, så hjælper vi dig med at vælge det rette kursus og afklare priser samt eventuelle tilskudsmuligheder via jobcenter eller a-kasse.",
  },
];

